export function cultureAdjustForJQueryUI(culture: string) {
    const cultureLow = culture.toLowerCase();

    if (cultureLow.startsWith("fi-")) {
        return "fi";
    }

    if (cultureLow.startsWith("sv-")) {
        return "sv";
    }

    if (cultureLow.startsWith("nb-")) {
        return "nb";
    }

    return culture;
}

export function getJQueryUIDatepickerFormat(culture: string) {
    switch (culture) {
        case "en":
        case "en-GB":
            return "dd/mm/yy";
        case "sv":
        case "sv-SE":
            return "yy-mm-dd";
        case "fi":
        case "fi-FI":
        case "sv-FI":
            return "d.m.yy";
        case "nb":
        case "nb-NO":
            return "dd.mm.yy";
        default:
            return "yy-mm-dd";
    }
}

export function cultureAdjustForMoment(culture: string) {
    const cultureLow = culture.toLowerCase();

    if (cultureLow.startsWith("fi-") || cultureLow === "sv-fi") {
        return "fi";
    }

    if (cultureLow.startsWith("sv-")) {
        return "sv";
    }

    if (cultureLow.startsWith("nb-")) {
        return "nb";
    }

    return cultureLow;
}

export function getMomentDateFormat(culture: string) {
    switch (culture) {
        case "en":
        case "en-GB":
            return {
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd, D MMMM YYYY HH:mm"
                }
            };
        case "sv":
        case "sv-SE":
            return {
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "YYYY-MM-DD",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY [kl.] HH:mm",
                    LLLL: "dddd D MMMM YYYY [kl.] HH:mm",
                    lll: "D MMM YYYY HH:mm",
                    llll: "ddd D MMM YYYY HH:mm"
                }
            };
        case "fi":
        case "fi-FI":
        case "sv-FI":
            return {
                longDateFormat: {
                    LT: "H:mm",
                    LTS: "H:mm:ss",
                    L: "D.M.YYYY",
                    LL: "Do MMMM[ta] YYYY",
                    LLL: "Do MMMM[ta] YYYY, [klo] H:mm",
                    LLLL: "dddd, Do MMMM[ta] YYYY, [klo] H:mm",
                    l: "D.M.YYYY",
                    ll: "Do MMM YYYY",
                    lll: "Do MMM YYYY, [klo] H:mm",
                    llll: "ddd, Do MMM YYYY, [klo] H:mm"
                }
            };
        case "nb":
        case "nb-NO":
            return {
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD.MM.YYYY",
                    LL: "D. MMMM YYYY",
                    LLL: "D. MMMM YYYY [kl.] HH:mm",
                    LLLL: "dddd D. MMMM YYYY [kl.] HH:mm"
                }
            };
        default:
            return {};
    }
}
